// extracted by mini-css-extract-plugin
export default {"card":"p0-z","carouselContainer":"q0-z","carouselContent":"r0-z"};